import {API, JSON_HEADER, JWT_HEADER} from 'config/srm.config';
import * as TYPES from './constants';
import {
  handleStudentSkillsStatusError,
  receiveStudentSkillsStatus,
  requestStudentSkillsStatus,
} from './actions';
const initialState = {
  request: null,
  data: null,
  error: null,
};
export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.REQUEST_STUDENT_SKILS_STATUS:
      return {
        ...state,
        request: true,
      };
    case TYPES.RECEIVE_STUDENT_SKILS_STATUS:
      return {
        ...state,
        data: action.payload,
        request: false,
      };
    case TYPES.STUDENT_SKILS_STATUS_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    default:
      return state;
  }
};

export const fetchSkillsStatus = student_uuid => (dispatch, getState) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();
  const config = {
    method: 'GET',
    mode: 'cors',
    headers: Object.assign({}, JWT_HEADER(token), JSON_HEADER),
    cache: 'default',
  };
  dispatch(requestStudentSkillsStatus());
  try {
    return fetch(
      `${API.student.studentSkills}?student_uuid=${student_uuid}`,
      config
    )
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Api Fails');
      })
      .then(json => {
        dispatch(receiveStudentSkillsStatus(json));
      })
      .catch(err => {
        console.log(err);
        dispatch(handleStudentSkillsStatusError(err));
      });
  } catch (err) {
    console.log(err);
    dispatch(handleStudentSkillsStatusError(err));
  }
};
